import { getFirestore, initializeFirestore } from "firebase/firestore";
import { app } from "./config";

let db;

try {
	db = initializeFirestore(app, {
		ignoreUndefinedProperties: true,
		experimentalAutoDetectLongPolling: true,
		useFetchStreams: false,
	});
} catch {
	db = getFirestore(app);
}

export { db };